<template>
	<v-toolbar color="transparent" dense flat class="in-video-controls">
		<v-spacer></v-spacer>
		<v-btn v-if="video || sharing_screen" @click="$emit('pin')" icon small text :color="isMain ? 'green' : 'black'" background-color="white"><v-icon small>{{ isMain ? 'mdi-pin' : 'mdi-pin-off'}}</v-icon></v-btn>
		<AVSettings v-if="fullControls" :editable="false" :settings="$props" :btnColor="btnColor"></AVSettings>
		<ScreenName v-if="local" v-bind="$props"></ScreenName>
		<v-chip v-else dark small color="black" append-icon="mdi-pencil">{{screenName}} </v-chip> 
	</v-toolbar>
</template>

<style lang="less">
	.in-video-controls{
		top: 0;
		width: 100%;
		position: absolute;
		z-index: 3;
		// margin-bottom: 40px;
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import ScreenName from "./ScreenName"
	import AVSettings from "./AVSettings"
	export default {
		name: "InVideoControls", 
		props: {
			track: {},
			sharing_screen:  {}, 
			video:  {}, 
			audio:  {}, 
			incognito:  {}, 
			screenName:  {},
			user: {}, 
			local: {},
			fullControls: {type: Boolean, default: false }, 
			isMain: {type: Boolean, default: false }, 
		},
		data: () => {
			return {
				btnColor: "black"
			}
		},
		components: {
			AVSettings, 
			ScreenName
		},
		computed: {
			allowEdit(){ 
				if( this.user == this.userObj.uid || this.role == "client" || this.role == "admin" ){
					return true;
				}
				return false;
			},
			...Vuex.mapState({
				userObj: state => state.auth.user,
				role: state => state.auth.view, 
			})
		},
		methods: {
		},
		watch: {
			settings: {
				immediate: true, 
				deep: true,
				handler(){
					const self = this;
					for( var key in self.settings ){
						self[key] = self.settings[key]
					}
				} 
			},
		}
		// created(){
			
		// }

	}
// </script>"